import api from './client';

export const getLabelPrinter  = ()        => api.get('/label-jobs/printer');
export const submitLabelJob   = (labels)  => api.post('/label-jobs', { labels });
